import React from "react";
import BenefitCard from "../../components/BenefitCard";
import { t } from "i18next";


const BenefitsSec = ({ data }) => {

  const benefitData = data?.contentItems

  return (
    <>
      <section className="career-listing-section">
        <div className="container">
          <h5 className="sub-title text-center">
            {data?.contentDescription}
          </h5>
          <h2 className="title text-center">{data?.contentTitle}</h2>
          <div className="row">
            {benefitData && benefitData.map((item, index) => {
              return (
                <BenefitCard key={index} title={item.sectionTitle} benefits={item.sectionItems} />
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default BenefitsSec;
